import "core-js/modules/es6.object.assign";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import { Text } from '@nerdwallet/react-typography';
import StarsRating from '@nerdwallet/react-star-rating';

var Rating = function Rating(_ref) {
  var rating = _ref.data,
      config = _ref.config;
  return typeof rating === 'undefined' ? React.createElement("div", {
    className: "stars-rating__no-rating"
  }, React.createElement(Text, {
    small: true,
    italic: true
  }, "Not rated")) : React.createElement("div", {
    className: "star-rating"
  }, React.createElement(StarsRating, _extends({
    nerdwallet: true,
    rating: rating
  }, config)));
};

Rating.propTypes = {
  data: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  config: PropTypes.object
};
export default Rating;